import * as React from 'react';
import { node } from 'prop-types';
import Grid from '../Grid';

const Columns = ({ children, ...rest }) => {
  const childCount = React.Children.count(children);
  return (
    <Grid
      maxWidth="100%"
      columns={childCount}
      equalColumns={false}
      justifyContent="flex-start"
      {...rest}
    >
      {children}
    </Grid>
  );
};

export default Columns;

Columns.propTypes = {
  children: node,
};
